export default {
  realTimeDataText: {
    allShopText:'所有门店',
    historyText:'历史',
    businessDataText:'营业数据',
    memberDataText:'会员营销',
    businessFlowText:'营业流水',
    liushuiText:'流水金额',
    vsLasWeekText:'比上周',
    vsYesterDayText:'比昨天',
    ssje:'实收金额',
    yhje:'优惠金额',
    yjds:'已结单数',
    wjje:'未结金额',
    wjds:'未结单数',
    mgcz:'敏感操作',
    sszt:'实时桌态',
    ztzyl:'桌台占用率',
    rankingText:'排行',
    djsq:'点击收起',
    lookMoreText:'查看更多',
    shopText:'门店',
    foodCategorizeText:'菜品分类',
    foodName:'菜品',
    numText:'单数',
    salesNumText:'销量',
    fzSalesNumText:'辅助销量',
    yygc:'营业构成',
    orderTypeText:'订单类型',
    tsText:'堂食',
    wmText:'外卖',
    ztText:'自提',
    channelTypeText:'渠道类型',
    mtText:'美团',
    elmText:'饿了么',
    posText:'POS',
    miniText:'小程序',
    yyqs:'营业趋势',
    nowText:'当前',
    lastWeekText:'上周',
    yesterDayText:'昨天',
    kl:'客流',
    peopleText:'人',
    yuan:'元',
    xfzb:'消费指标',
    klrs:'客流人数',
    zqkj:'折前客均',
    zhkj:'折后客均',
    zqdj:'折前单均',
    zhdj:'折后单均',
    cpmgcz:'菜品敏感操作',
    giveFoodText:'赠菜(次数/金额)',
    returnFoodText:'退菜(次数/金额)',
    changePriceText:'改价(次数/金额)',
    discountText:'打折(次数/金额)',
    giveFoodText1:'赠菜',
    returnFoodText1:'退菜',
    changePriceText1:'改价',
    discountText1:'打折',
    zdmgcz:'账单敏感操作',
    tds:'退单数',
    xgzdcs:'修改账单次数',
    searchText:'输入门店名称搜索',
    nosearchdataText:'暂无搜索数据',
    orderNoText:'账单号',
    dishNameText:'菜品名称/规格',
    quantityText:'数量',
    amountText:'金额',
    timeText:'时间',
    personnelText:'人员',
    reasonText:'原因',
    allloadedText:'已全部加载完',
    loadingText:'加载中...',
    noDataText:'暂无数据',
    zdlbText:'账单列表',
    djzText:'待结账',
    yjzText:'已结账',
    tableText1:'桌台',
    numText1:'就餐人数',
    billAmountText:'账单金额',
    billDetailsText:'账单详情',
    subtotalText:'小计',
    totalText:'总计',
    actualPaymentText:'实收科目',
    discountItemsText:'优惠科目',
    checkoutTimeText:'结账时间',
    orderTimeText:'下单时间',
  },
  historyDataText:{
    sjglText:'数据概览',
    dayText:'日',
    weekText:'周',
    monthText:'月',
    quarterText:'季',
    yearText:'年',
    customText:'自定义',
    selectDateText:'选择日期',
    dateText:'日期',
    confirmText:'确定',
    salesFlowText:'流水',
    actualReceivedText:'实收',
    yhjezbText:'优惠金额/占比',
    zdsText:'账单数',
    klsText:'客流数',
    zdgcText:'账单构成',
    channelText:'渠道',
    keleiText:'客类',
    payTypeText:'支付科目',
    tableText:'桌台统计',
    kaitaiText:'开台率',
    fantaiText:'翻台率',
    shangzuoText:'上座率',
    mondayText:'一',
    tuesdayText:'二',
    wednesdayText:'三',
    thursdayText:'四',
    fridayText:'五',
    saturdayText:'六',
    sundayText:'日',
    startText:'开始',
    endText:'结束',
    realTimeText:'实时',
  },
  memberDataInfoText:{
    memberTotalText:'会员总量/卡总量',
    addMemberText:'新增会员',
    addMemberCardText:'新增会员卡',
    hyxfjeText:'会员消费金额',
    xfxjkzText:'消费现金卡值',
    xfzskzText:'消费赠送卡值',
    hyczjeText:'会员储值金额',
    czxjkzText:'储值现金卡值',
    czzskzText:'储值赠送卡值',
    memberOrderNumText:'会员订单数量',
    hyldlsText:'会员拉动流水',
    hyldssText:'会员拉动实收',
    huanbiText:'环比',
    tongbiText:'环比',
   }
}
